// extracted by mini-css-extract-plugin
module.exports = {"formattedDate":"FormatDate_formattedDate__rnxcI"};